import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useSettingParams } from '../../../common/filterCompany/useSettingParams'
import { Panel } from '../../../common/panel'
import { DEFAULT_CHART_HIGHT } from '../businessDistribution'
import { HIGH_LIGHT_TITLE } from '../constants'
import withLoadingFeedBack from '../hoc/withLoadingFeedback'
import BaseContainer from './BaseContainer'
import { selectLoading, selectScoreYearOfOperation } from './store/slice'
import { exportYearOperation, getYearOperation } from './store/thunk'

const YearOperation = () => {
  const dispatch = useDispatch()
  const settingParams = useSettingParams()

  const data = useSelector(selectScoreYearOfOperation())
  const locale = useSelector((state) => state.i18n.locale)
  const isLoading = useSelector(selectLoading)

  const Container = withLoadingFeedBack(
    isLoading,
    data,
    DEFAULT_CHART_HIGHT,
  )(BaseContainer)

  useEffect(() => {
    if (!settingParams) return
    dispatch(getYearOperation(settingParams))
  }, [settingParams, locale])

  return (
    <Panel
      label="portfolio.segment.YEARS_OF_OPERATION_DISTRIBUTION"
      isI18n={true}
      renderLabel={() => (
        <>
          &nbsp;
          <Translate
            className="fstItalic"
            value={'portfolio.segment.BASE_ON'}
          />
        </>
      )}
      downloadCsv={{ downloadFunc: () => exportYearOperation(settingParams) }}
      className={HIGH_LIGHT_TITLE.mostPopularYearsOfOperation}
    >
      <Container />
    </Panel>
  )
}

export default YearOperation
